import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Link,
} from '@mui/material';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitch,
  faTwitter,
  faYoutube,
  faTiktok,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import {
  faCoffee,
  faGift,
  faCloud,
} from '@fortawesome/free-solid-svg-icons';
import Credits from '../components/Credits';

const socialLinks = [
  { 
    name: 'Ko-fi', 
    url: 'https://ko-fi.com/runerek',
    icon: faCoffee,
    color: '#FF5E5B'
  },
  { 
    name: 'Twitch', 
    url: 'https://twitch.tv/runerek',
    icon: faTwitch,
    color: '#9146FF'
  },
  { 
    name: 'Twitch (Alt)', 
    url: 'https://twitch.tv/notrunerek',
    icon: faTwitch,
    color: '#9146FF'
  },
  { 
    name: 'Twitter', 
    url: 'https://twitter.com/runerek',
    icon: faTwitter,
    color: '#1DA1F2'
  },
  { 
    name: 'Twitter (Alt)', 
    url: 'https://twitter.com/runerekalt',
    icon: faTwitter,
    color: '#1DA1F2'
  },
  { 
    name: 'YouTube (Runerek)', 
    url: 'https://www.youtube.com/channel/UChUcBbqoOqkKbap6tARf4qg',
    icon: faYoutube,
    color: '#FF0000'
  },
  { 
    name: 'YouTube (Archives)', 
    url: 'https://www.youtube.com/channel/UCM490c9712XFFPtBC7PmuAA',
    icon: faYoutube,
    color: '#FF0000'
  },
  { 
    name: 'TikTok', 
    url: 'https://www.tiktok.com/@runerek?is_from_webapp=1&sender_device=pc',
    icon: faTiktok,
    color: '#000000'
  },
  { 
    name: 'TikTok Live', 
    url: 'https://www.tiktok.com/@runereklive?is_from_webapp=1&sender_device=pc',
    icon: faTiktok,
    color: '#000000'
  },
  { 
    name: 'Throne', 
    url: 'https://throne.com/runerek',
    icon: faGift,
    color: '#6B46C1'
  },
  { 
    name: 'Bluesky', 
    url: 'https://bsky.app/profile/runerek.bsky.social',
    icon: faCloud,
    color: '#00A8E8'
  },
  { 
    name: 'Instagram', 
    url: 'https://www.instagram.com/runerek_/',
    icon: faInstagram,
    color: '#E4405F'
  },
];

function Home() {
  return (
    <Box>
      <Box
        sx={{
          background: `
            linear-gradient(135deg, 
              #c7401A 0%, 
              #9d200b 50%, 
              #45040c 100%
            )
          `,
          color: 'white',
          py: 8,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 20% 80%, rgba(199, 64, 26, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(129, 36, 15, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 40% 40%, rgba(157, 32, 11, 0.2) 0%, transparent 50%)
            `,
            zIndex: 1,
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%)',
            zIndex: 2,
          }
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 3 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={6}>
              <Box
                  component="img"
                  src="/home_logo.png"
                  alt="Runerek Logo"
                  sx={{
                    width: '100%',
                    maxWidth: { xs: '250px', sm: '350px', md: '450px' },
                    height: 'auto',
                    display: 'block',
                    margin: 'auto',
                    filter: 'drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3))',
                    mb: 2,
                  }}
                />                <Typography 
                  variant="h5" 
                  sx={{ 
                    mb: 4,
                    fontSize: { xs: '1.2rem', sm: '1.5rem' },
                    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
                    opacity: 0.95,
                  }}
                >
                  Red Panda VTuber | Content Creator
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <Button
                    component={RouterLink}
                    to="/gallery"
                    variant="contained"
                    size="large"
                    sx={{
                      bgcolor: 'background.paper',
                      color: 'text.primary',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                      '&:hover': {
                        bgcolor: 'primary.light',
                        color: 'background.paper',
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.3)',
                        transform: 'translateY(-2px)',
                      },
                      transition: 'all 0.3s ease-in-out',
                    }}
                  >
                    View Art Gallery
                  </Button>
                  <Button
                    href="https://runerek-shop.fourthwall.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    size="large"
                    sx={{
                      bgcolor: 'background.paper',
                      color: 'text.primary',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                      '&:hover': {
                        bgcolor: 'primary.light',
                        color: 'background.paper',
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.3)',
                        transform: 'translateY(-2px)',
                      },
                      transition: 'all 0.3s ease-in-out',
                    }}
                  >
                    Shop Merch
                  </Button>
                </Box>              </Grid>
              <Grid 
                item 
                xs={12} 
                md={6}
                sx={{
                  order: { xs: -1, md: 2 }
                }}
              >
                <Box
                  component="img"
                  src="/hero.png"
                  alt="Runerek"
                  sx={{
                    width: '100%',
                    maxWidth: 500,
                    height: 'auto',
                    display: 'block',
                    margin: 'auto',
                    filter: 'drop-shadow(0 8px 16px rgba(0, 0, 0, 0.3))',
                  }}
                />
              </Grid>
            </Grid>
          </motion.div>
        </Container>
      </Box>

      <Container 
        maxWidth="lg" 
        sx={{ 
          py: 8,
          background: `
            linear-gradient(180deg, 
              rgba(199, 64, 26, 0.02) 0%, 
              transparent 50%
            )
          `
        }}
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <Typography 
                variant="h2" 
                gutterBottom 
                color="text.primary" 
                textAlign="center"
                sx={{
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)',
                }}
              >
                Connect With Me
              </Typography>
             
            </motion.div>
          </Grid>
          {socialLinks.map((social, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={`${social.name}-${index}`}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <Card 
                  sx={{ 
                    height: '100%',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
                    }
                  }}
                >
                  <CardContent sx={{ textAlign: 'center', py: 3 }}>
                    <Box sx={{ mb: 2 }}>
                      <FontAwesomeIcon 
                        icon={social.icon} 
                        size="2x" 
                        style={{ color: social.color }}
                      />
                    </Box>
                    <Typography variant="h6" gutterBottom>
                      {social.name}
                    </Typography>
                    <Link
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="primary"
                      sx={{ 
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      {social.name}
                    </Link>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
           
        </Grid>
      </Container>
      <Credits/>
    </Box>
  );
}

export default Home;